import React from 'react';
import PropTypes from 'prop-types';
// import { propTypes as rowPropTypes } from './row';
import VideoCard from '../card/video_card';
import getUniqueKeyForCard from '../../utils/getUniqueKeyForCard';
import withViewportScrollTracking from '../hocs/withViewportScrollTracking';
import {map, take} from 'lodash';

export const FourVideoRow = ({
  cards,
  dataAttributes,
  type
}, {
  isPreviewPage
}) => {
  const fourVideoCards = map(take(cards, 4), (card) => {
    const key = getUniqueKeyForCard(card, isPreviewPage);
    const cardProps = {
      ...card,
      key,
      rowType: type
    };
    return <VideoCard {...cardProps} />;
  });
  return (
    <div className="row four-video" {...dataAttributes} >
      <h2 className="four-video-title">Trending Videos</h2>
      <div className="four-video-content">
        {fourVideoCards}
      </div>
    </div>
  );
};

// FourVideoRow.propTypes = Object.assign({ ...rowPropTypes }, {
//   dataAttributes: PropTypes.object.isRequired
// });

FourVideoRow.defaultProps = {
  dataAttributes: {}
};

FourVideoRow.contextTypes = {
  isPreviewPage: PropTypes.bool.isRequired
};

const decorator = withViewportScrollTracking({
  eventParams() {
    return [
      'Scroll Depth',
      'Scroll',
      'Trending Videos'
    ];
  }
});

export default decorator(FourVideoRow);
